import { UPDATE_MENU_INDEX } from "../actions/returnType";
import { menuStateData } from "../constants/initalStateData";

export const commonReducer = (state = menuStateData, action) => {
  switch (action.type) {
    case UPDATE_MENU_INDEX:
      return {
        ...state,
        index: action.index,
      };
    default:
      return state;
  }
};
